import { Fragment, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import * as _ from 'lodash';
import { fetchClearFavorites, setSelectedClearFavoritesSport } from 'stores/match/index.js';
import MatchCard from 'components/general/match_card.js';
import SportDetailItem from 'components/SportDetailItem.js';
import { eventsToGroup } from 'toolkit/eventsToGroup.js';
import { getSportTypeToActiveIcon, getSportTypeToWhiteIcon } from 'toolkit/utils';
import GoBack from 'components/general/go_back';
import { Col, Row } from 'react-bootstrap';
import { AWS_BUCKET_URL } from 'toolkit/constants';

function ClearFavorites() {
  const dispatch = useDispatch();
  const selectedClearFavoritesSport = useSelector(
    (state) => state.match.selectedClearFavoritesSport
  );
  const clearFavoritesEvents = useSelector(
    (state) => {
      const { clearFavorites, events } = state.match;
      return clearFavorites
        .map((c) => events[c])
        .filter((match) => {
          if (!match || !match.markets) return false;
          return (
            match.markets[0].outcomes[0]?.odds !== null ||
            match.markets[0].outcomes[1]?.odds !== null ||
            match.markets[0].outcomes[2]?.odds !== null
          );
        });
    },
    (a, b) => a.length === b.length
  );
  const selectedLocale = useSelector((state) => state.match.selectedLocale);
  const locales = useSelector((state) => state.match.locales);
  const { t } = useTranslation('translations', { useSuspense: false });
  const [sports, setSports] = useState({});
  const [sport, setSport] = useState('0');
  const location = useLocation();
  const [selectedMarketType, setSelectedMarketType] = useState(1);

  useEffect(() => {
    dispatch(fetchClearFavorites({ size: 0, sportType: '0' }));
  }, []);

  useEffect(() => {
    const groups = eventsToGroup(clearFavoritesEvents);
    setSports(groups);

    if ((sport === '' || Object.keys(sport).length === 0) && clearFavoritesEvents.length > 0) {
      setSport(
        selectedClearFavoritesSport !== null ||
          sports.hasOwnProperty(Number.parseInt(selectedClearFavoritesSport)) === true
          ? selectedClearFavoritesSport
          : Number.parseInt(Object.keys(groups)[0])
      );
    }
  }, [clearFavoritesEvents]);

  const selectSport = useCallback((id) => {
    setSport(id);
    dispatch(setSelectedClearFavoritesSport(id));
  });

  const calculateMenuItemsDynamic = () => {
    const menuItems = [];
    let icon = '';
    Object.keys(sports).map((sportType, index) => {
      if (sportType === sport) {
        icon = getSportTypeToActiveIcon(sport);
      } else {
        icon = getSportTypeToActiveIcon(sportType);
      }

      if (sports[sportType].length > 0) {
        menuItems.push(
          <SportDetailItem
            key={index}
            active={sport === sportType}
            count={_.sum(sports[sportType].map((l) => l.matches.length))}
            icon={icon}
            onClick={() => {
              selectSport(sportType);
            }}
            text={t('sports.' + sportType)}
            className={'d-flex flex-column p-2 fs-9'}
          />
        );
      }
    });
    return menuItems;
  };

  function getBetType() {
    const betTypes = [
      {
        label: t('winner'),
        id: 1
      },
      {
        label: t('overunder'),
        id: 18
      },
      {
        label: t('handicap'),
        id: 14
      },
      {
        label: t('nextGoal'),
        id: 8
      },
      {
        label: t('bs'),
        id: 29
      },
      {
        label: t('doubleChance'),
        id: 10
      }
    ];
    return (
      <div className="tip-types">
        {betTypes.map((betType) => (
          <div className="d-inline-block w-25 fw-bold " key={betType.id}>
            <button
              className={`btn btn-sm w-100 border fs-8 ${selectedMarketType === betType.id ? 'btn-primary fw-bold text-white' : 'btn-light'
                }`}
              onClick={() => setSelectedMarketType(betType.id)}>
              {betType.label}
            </button>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="container-fluid scrollable-y">
      <div
        className="overflow-auto text-nowrap bg-dark mx-n3 d-flex align-items-center justify-content-between px-2"
        style={{ minHeight: '36px', paddingTop: '4px', paddingBottom: '4px' }}>
        <div
          style={{
            flexShrink: 0,
            padding: '2px 4px',
            borderRadius: '4px',
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background-color 0.2s ease'
          }}
          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'}
          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.12)'}>
          <div style={{ transform: 'scale(0.7)', filter: 'invert(1) brightness(2)' }}>
            <GoBack />
          </div>
        </div>
        <div className="d-flex flex-nowrap overflow-auto gap-0" style={{ flex: 1, minWidth: 0, marginLeft: '4px' }}>
          {calculateMenuItemsDynamic()}
        </div>
      </div>
      {sport === '0' && (
        <Row className="">
          <Col className="tip-types-container">{getBetType()}</Col>
        </Row>
      )}
      <div className="">
        {sport !== '' &&
          sports[sport] !== undefined &&
          sports[sport].length > 0 &&
          sports[sport].map((leagueGroup, index) => {
            let code = null;
            if (
              leagueGroup.matches &&
              leagueGroup.matches.length > 0 &&
              leagueGroup.matches[0].categoryId
            ) {
              code = leagueGroup.matches[0].categoryId.split(':')[2];
            }
            return (
              <Fragment
                key={
                  'leaguenamesfragment' +
                  leagueGroup.category +
                  leagueGroup.league +
                  leagueGroup.matches[0].gameNumber +
                  index
                }>
                <div
                  className="text-start pb-2 fw-bold pt-1 fs-7"
                  key={
                    'leaguenames' +
                    leagueGroup.category +
                    leagueGroup.league +
                    leagueGroup.matches[0].gameNumber
                  }>
                  {code && (
                    <img
                      width="20"
                      height="13"
                      src={`${AWS_BUCKET_URL}/ClientFlags/${code}.svg`}
                      alt={code}
                      className="me-2"
                    />
                  )}
                  {leagueGroup.category + ' / ' + leagueGroup.league}
                </div>
                {leagueGroup.matches.map((match, index) => (
                  <MatchCard
                    key={match.providerId}
                    providerId={match.providerId}
                    marketType={selectedMarketType}
                    index={index}
                    sport={sport}
                    path={location.pathname}
                    locales={locales}
                    selectedLocale={selectedLocale}
                  />
                ))}
              </Fragment>
            );
          })}
      </div>
    </div>
  );
}

export default ClearFavorites;
